if (!customElements.get("announcement-slider")) {
  function setupNavButtons(emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => {
      emblaApi.scrollPrev();
    };
    const scrollNext = () => {
      emblaApi.scrollNext();
    };
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    return () => {
      prevBtn.removeEventListener("click", scrollPrev, false);
      nextBtn.removeEventListener("click", scrollNext, false);
    };
  }

  class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector(".embla__viewport");
      const plugins = [EmblaCarouselClassNames()];
      if (this.dataset.autoplay) {
        this.autoplay = EmblaCarouselAutoplay();
        plugins.push(this.autoplay);
      }
      this.slider = EmblaCarousel(
        this.viewport,
        {
          loop: true,
          align: "start",
          inViewThreshold: 1,
        },
        plugins
      );

      const prevBtn = this.querySelector(".embla__prev-button");
      const nextBtn = this.querySelector(".embla__next-button");
      if (prevBtn && nextBtn) {
        setupNavButtons(this.slider, prevBtn, nextBtn);
      }

      if (this.autoplay) {
        this.slider.on("select", () => this.autoplay.reset());
      }
    }
  }

  customElements.define("announcement-slider", AnnouncementSlider);
}
